module.exports = __webpack_public_path__ + "img/urkunde.acd9ade5.jpg";